import { CommonModule } from '@angular/common'
import { CUSTOM_ELEMENTS_SCHEMA, Component, ContentChild, ElementRef, TemplateRef, ViewChild, inject, input, output } from '@angular/core'
import { AssetCardComponent } from '../asset-card/asset-card.component'
import { Router, RouterModule } from '@angular/router'
import { IAsset } from 'src/app/core/interfaces/asset.interface'
import { v4 as uuidv4 } from 'uuid'
import { MatButtonModule } from '@angular/material/button'
import { takeUntilDestroyed, toObservable } from '@angular/core/rxjs-interop'
import { IComponentConfig } from 'src/app/core/interfaces/config.interface'
import { CurrencyCode } from 'src/app/core/interfaces/currency.interface'

@Component({
  selector: 'app-asset-carousel',
  templateUrl: './asset-carousel.component.html',
  styleUrls: ['./asset-carousel.component.scss'],
  imports: [
    CommonModule,
    AssetCardComponent,
    RouterModule,
    MatButtonModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AssetCarouselComponent {
  router = inject(Router)

  assets = input<IAsset[]>()
  viewAllLink = input('')
  viewAllQueryParams = input({})
  currencyCode = input<CurrencyCode>(CurrencyCode.USD)
  assetCardDefaultImage = input<string>('')
  assetCardConfig = input<IComponentConfig>()
  cardClick = output<string>()
  contactClick = output<IAsset>()

  @ContentChild('titleTemplate') titleTemplate!: TemplateRef<any>
  @ViewChild('carouselWrapper') carouselWrapper!: ElementRef

  hasNavigationControls: boolean = false
  carouselId = `carousel-${uuidv4()}`

  constructor() {
    toObservable(this.assets).pipe(
      takeUntilDestroyed(),
    ).subscribe(() => {
      setTimeout(() => {
        this.swiperInit()
      }, 0)
    })
  }

  swiperInit() {
    const assets = this.assets() ?? []
    if (!assets || !assets.length) {
      return
    }

    this.hasNavigationControls = assets.length > 4

    const carouselWrapperParams = {
      slidesPerView: 'auto',
      speed: 500,
      loop: false,
      spaceBetween: 24,
      keyboard: {
        enabled: false,
      },
      navigation: {
        nextEl: `.${this.carouselId}-next`,
        prevEl: `.${this.carouselId}-prev`,
      },
      breakpoints: {
        768: {
          allowTouchMove: false,
        }
      }
    }
    Object.assign(this.carouselWrapper.nativeElement, carouselWrapperParams)
    this.carouselWrapper.nativeElement.initialize()
  }
}
